import { Table, TableCell, TableContainer, TableRow, Typography } from '@mui/material';
import React from 'react'
import FunctionsIcon from '@mui/icons-material/Functions';
import AddIcon from '@mui/icons-material/Add';
import moment from 'moment';

function AnimalListItemVertical({ sumInsuredData, tableListDatas, groupDetails }) {
    return (
        <TableContainer sx={{ mt: 0 }}>

            <Table
                size="small"
                aria-label="a dense table"
                className="sum_insured_table"
            >
                {sumInsuredData?.sumInsuredHeaderSorted.map((head) => {
                    return <TableRow>
                        <TableCell style={{ width: '36.3vw', paddingLeft: '16px' }}>
                            <div
                            //  className={(head.isSuminsured || head.horizontalSum) ? 'suminsuredHead' : ''}
                            >
                                {/* {head.isSuminsured && <FunctionsIcon style={{ marginLeft: '-5px' }} />} */}
                                {/* {head.horizontalSum && <AddIcon style={{ marginLeft: '-5px' }} />} */}
                                {head.title ? head.title : head.sumInsuredHeader.title}
                                {head.description && <span>*</span>}
                            </div>

                        </TableCell>
                        {tableListDatas?.map((_, index) => {
                            return (
                                <React.Fragment
                                    key={index}
                                >

                                    {sumInsuredData?.sumInsuredHeaderSorted.map((item) => {
                                        const attr = item.sumInsuredHeader.attribute;
                                        const headAttr = head.sumInsuredHeader.attribute;
                                        const value = tableListDatas[index][attr];

                                        if (attr !== headAttr) return null;

                                        const isFinancialField = item.isSuminsured || item.horizontalSum;

                                        const formattedValue = () => {
                                            if (
                                                value === null ||
                                                value === undefined ||
                                                (Array.isArray(value) && value.length === 0)
                                            ) return 'N/A';

                                            // Date fields
                                            const dateFields = ['dob', 'dateOfCoverage', 'notInPolicyPeriod'];
                                            if (dateFields.includes(attr)) {
                                                return moment(value).format('YYYY-MM-DD');
                                            }

                                            // Array values
                                            if (Array.isArray(value)) {
                                                return value.map(v => {
                                                    if (isFinancialField) {
                                                        return new Intl.NumberFormat('en-IN', {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2,
                                                        }).format(Number(v ?? 0));
                                                    }
                                                    return v;
                                                }).join(', ');
                                            }

                                            // Financial fields
                                            if (isFinancialField) {
                                                return new Intl.NumberFormat('en-IN', {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                }).format(Number(value ?? 0));
                                            }

                                            // Default
                                            return value;
                                        };

                                        return (
                                            <TableCell
                                                className="Pad3"
                                                key={attr}
                                                style={{ paddingLeft: '0px' }}
                                            >
                                                {formattedValue()}
                                            </TableCell>
                                        );
                                    })}


                                </React.Fragment>
                            );
                        })}
                    </TableRow>
                })}
                {parseFloat(groupDetails.totalSumInsured) > 0 && sumInsuredData.showTotalSumInsured ? (
                    <TableRow>
                        <TableCell className='Pad3'

                        ><Typography variant="h5" style={{ marginTop: 9, textAlign: 'right' }}>
                                Total
                            </Typography></TableCell>
                        <TableCell className='Pad3' >
                            <Typography variant="h5" style={{ marginTop: 9, textAlign: 'left' }}>
                                : {new Intl.NumberFormat('en-IN', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                }).format(Number(groupDetails?.totalSumInsured ?? 0))}
                            </Typography>
                        </TableCell>
                    </TableRow>
                ) : null}

            </Table>

        </TableContainer>
    )
}

export default AnimalListItemVertical